import Vue from 'vue';
import { Component, Ref, Watch, Prop } from 'vue-property-decorator';
import { qsa } from '@/utils/domUtils';

@Component({})
export default class SvgImage extends Vue {
  @Prop({ type: String, default: 'icon' })
  readonly svgType!: string;

  @Prop({ type: String, default: '' })
  readonly svg: string;

  @Prop({ type: String, default: '' })
  readonly code: string;

  @Watch('code')
  svgChanged() {
    if (this.code) {
      this.setSvgCabins();
    } else {
      this.resetSvgCabins();
    }
  }

  setSvgCabins() {
    const svgObject = this.$el;

    this.resetSvgCabins();
    if (!svgObject?.querySelectorAll) return;

    const codeCabin = `cabin-${this.code}`;
    const allSvgNodesByCabin = qsa('[id*="cabin-"]', svgObject as HTMLElement);

    if (allSvgNodesByCabin) {
      const hasCategory = allSvgNodesByCabin.some((c) => c.id === codeCabin);

      allSvgNodesByCabin.forEach((n) => {
        if (hasCategory) {
          n.classList.add(n.id === codeCabin ? 'active' : 'notActive');
        }
      });
    }
  }

  resetSvgCabins() {
    const targetSvg = this.$el;
    if (targetSvg?.querySelectorAll) {
      const allSvgNodesByCabin = targetSvg.querySelectorAll('[id*="cabin-"]');
      allSvgNodesByCabin.forEach((e) => {
        e.classList.remove('active');
        e.classList.remove('notActive');
      });
    }
  }
}
